import { createFileRoute, Navigate } from '@tanstack/react-router';
import { getDefaultView } from '@/utils/viewHelpers';
import { DocumentHead } from '@/components/core/DocumentHead';

export const Route = createFileRoute(
  '/$tenantId/_layout/departments/_layout/$departmentId/',
)({
  component: DepartmentRedirect,
});

function DepartmentRedirect() {
  const { tenantId, departmentId } = Route.useParams();
  const view = getDefaultView('department');

  return (
    <>
      <DocumentHead
        titleKey="page.department.details.title"
        descriptionKey="page.department.details.description"
        resetOnUnmount={false}
      />
      <Navigate
        to="/$tenantId/departments/$departmentId/$view"
        params={{
          tenantId,
          departmentId,
          view,
        }}
        replace
      />
    </>
  );
}
